import type { BoxProgramApiGateway } from "@/modules/boxProgrammation/gateway/boxProgramApiGateway"
import {
  type BoxProgramDetailsDto,
  BoxProgramDetailsDtoSchema,
  type BoxProgramItemDto,
  BoxProgramItemDtoSchema,
  type CreateBoxProgramInputDto,
  CreateBoxProgramInputDtoSchema,
  type UpdateBoxProgramInputDto,
  UpdateBoxProgramInputDtoSchema,
} from "@/modules/boxProgrammation/gateway/boxProgramDto"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { type Paginated } from "@modules/utils/paginated"

export class BoxProgramApi implements BoxProgramApiGateway {
  private programBaseUrl = "/box/programs"

  constructor(private api: ApiClient) {}

  async getBoxPrograms(page = 0, size = 50): Promise<Paginated<BoxProgramItemDto>> {
    const result = await this.api.get<Paginated<BoxProgramItemDto>>(`${this.programBaseUrl}`, {
      params: {
        page,
        size,
        filter: "ALL",
        order: "SUBSCRIPTION_DATE",
      },
    })
    return {
      ...result.data,
      content: result.data.content.map((program) => LoggerService.parseApiDto(BoxProgramItemDtoSchema, program)),
    }
  }

  async getBoxProgram(id: string): Promise<BoxProgramDetailsDto> {
    const resultDto = await this.api.get<BoxProgramDetailsDto>(`${this.programBaseUrl}/${id}`)
    return LoggerService.parseApiDto(BoxProgramDetailsDtoSchema, resultDto.data)
  }

  async deleteBoxProgram(id: string): Promise<void> {
    await this.api.delete(`${this.programBaseUrl}/${id}`)
  }

  async createBoxProgram(boxProgram: CreateBoxProgramInputDto): Promise<BoxProgramDetailsDto> {
    const resultDto = await this.api.post<BoxProgramDetailsDto>(
      `${this.programBaseUrl}`,
      LoggerService.parseApiDto(CreateBoxProgramInputDtoSchema, boxProgram),
    )
    return LoggerService.parseApiDto(BoxProgramDetailsDtoSchema, resultDto.data)
  }

  async updateBoxProgram(id: string, boxProgram: UpdateBoxProgramInputDto): Promise<BoxProgramDetailsDto> {
    const resultDto = await this.api.put<BoxProgramDetailsDto>(
      `${this.programBaseUrl}/${id}`,
      LoggerService.parseApiDto(UpdateBoxProgramInputDtoSchema, boxProgram),
    )
    return LoggerService.parseApiDto(BoxProgramDetailsDtoSchema, resultDto.data)
  }
}
